import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import { messages } from 'lang/messages/messages';
import { actions } from 'react-table';

const initialState = {
    notificationList: {},

};

const NotificationSlice = createSlice({
    name: 'notifylist',
    initialState,
    reducers: {
        setNotificationList(state, action) {
            state.notificationList = action.payload;
        },


    },
});



export const AuthorNotificationListApi = (tokendata, page, limit) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/publisher/notificationList?type=author&page=${page}&limit=${limit}`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            dispatch(setNotificationList(res?.data?.data))
            // dispatch(setToast({
            //     status: true, message: res?.data?.message
            // }))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");


        })

}
export const EditorNotificationListApi = (tokendata, page, limit) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/publisher/notificationList?type=editor&page=${page}&limit=${limit}`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            dispatch(setNotificationList(res?.data?.data))
            // dispatch(setToast({
            //     status: true, message: res?.data?.message
            // }))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");


        })

}



export const { setNotificationList } = NotificationSlice.actions;
const NotificationReducer = NotificationSlice.reducer;

export default NotificationReducer;
